module.exports = __webpack_public_path__ + "img/right_2.4c101bdc.jpg";